export interface CreateEntityModalState {
  description: string;
  existingEntityNames: Set<string>;
  saving: Promise<void>;
  name: string;
  submitAttempted: boolean;
  open: boolean;
  globalAccessType: string;
}

export interface CreateEntityModalAttrs {
  closeable: boolean;
  'entity-type': string;
  'is-editing': boolean;
  'initial-description': string;
  'initial-name': string;
  'modal-title': string;
  open: boolean;
  warning: string;
  'project-id': number;
  'show-share-management': boolean;
  'show-global-access-menu': boolean;
  'visibility-controls-message': string;
  'show-copy-link-button': boolean;
}

export enum GlobalAccessType {
  OFF = `Just me`,
  VIEWER = `Everyone can view`,
  EDITOR = `Everyone can edit`,
}

export interface ModalValues {
  name: string;
  description: string;
  globalAccessType?: GlobalAccessType;
}

export interface ModalReturn extends ModalValues {
  clearOpenShareUponSave?: boolean;
  didSave: boolean;
  didShare: boolean;
  event: string;
  value?: ModalValues; // for saveAndShare case
}

export enum TemplateType {
  KPI = `kpi`,
}
